import constants from './constants';

function blurField(field) {
  return dispatch => {
    dispatch({ type: constants.BLUR_FIELD, field });
  };
}

function destroyField(field) {
  return dispatch => {
    dispatch({ type: constants.DESTROY_FIELD, field });
  };
}

function focusField(field) {
  return dispatch => {
    dispatch({ type: constants.FOCUS_FIELD, field });
  };
}

function updateField(field) {
  return dispatch => {
    dispatch({ type: constants.UPDATE_FIELD, field });
  };
}

function initializeField(field) {
  return dispatch => {
    dispatch({ type: constants.INITIALIZE_FIELD, field });
  };
}

function syncField(field) {
  return dispatch => {
    dispatch({ type: constants.SYNC_FIELD, field });
  };
}

function submitForm() {
  return dispatch => {
    dispatch({ type: constants.SUBMIT_FORM });
  };
}

export default {
  blurField,
  destroyField,
  focusField,
  updateField,
  initializeField,
  syncField,
  submitForm,
};



// WEBPACK FOOTER //
// ./src/features/Form/actions.js